import { useEffect, useState } from 'react';
import { countryRepository } from '@shared/domain/country/country.repository';
import { Country } from '@shared/domain/country/country.aggregate';
import {
  useAppSelector,
  useAppDispatch
} from '@shared/infrastructure/state/store';
import {
  countryCodeSelector,
  setCountryCodeAction
} from '@shared/infrastructure/state/global.slice';
import { Box, SelectChangeEvent, Autocomplete, TextField } from '@mui/material';

export const CountrySelector = () => {
  const dispatch = useAppDispatch();
  const countryCode = useAppSelector(countryCodeSelector);
  const [country, setCountry] = useState<Country>();
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    countryRepository.getCountries().then((res) => {
      setCountries(res || []);
      setCountry(res.find((c) => c.code === countryCode));
    });
  }, []);

  const handleChange = (_: any, value: Country) => {
    console.log('handleChange: changing value to ' + value?.code);
    dispatch(setCountryCodeAction(value.code));
    setCountry(countries.find((c) => c.code === value.code));
  };

  return (
    <Box sx={{ minWidth: 160, mr: 1 }}>
      <Autocomplete
        key={country ? country.code : 'none'}
        disableClearable
        color='secondary'
        options={countries}
        getOptionLabel={(country) => country.name}
        renderInput={(params) => (
          <TextField color='secondary' {...params} label='Country' />
        )}
        value={country}
        onChange={handleChange}
        size='small'
        sx={{
          color: 'white',
          minWidth: 160,
          '& .MuiAutocomplete-popupIndicatorOpen': {
            color: 'white'
          },
          '& .MuiInputBase-input[aria-expanded="true"]': {
            color: 'white'
          }
        }}
      />
    </Box>
  );
};
